
<div>
    <app-bar :title="club.name"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8">
            <div class="pb-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <v-btn
                    v-if="permitted('admin_club_management')"
                    class="sm mr-5"
                    color="primary"
                    outlined
                    @click.prevent="suspend(club)"
                >
                    {{ club.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_club_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="del(club)"
                >
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                <img
                    v-if="club.photoUrl"
                    :src="club.photoUrl"
                    width="150"
                />
                <div class="form-subtitle">{{ t('club_label_description') }}:</div>
                <div class="form-subtitle-description" v-html="club.description"></div>
                <template v-if="club.photos && club.photos.length">
                    <div class="form-subtitle mb-3">{{ t('club_label_header_photos') }}:</div>
                    <v-row>
                        <v-col
                            v-for="photo in club.photos"
                            :key="photo"
                            cols="6"
                        >
                            <v-sheet
                                color="white"
                                elevation="0"
                                height="185"
                                width="185"
                                rounded="lg"
                                class="pt-6"
                            >
                                <v-img
                                    :lazy-src="photo"
                                    :src="photo"
                                    max-height="135"
                                    max-width="135"
                                    class="mx-auto"
                                ></v-img>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </template>
            </div>
            <div class="float-left" style="max-width: calc(100% - 434px)">
                <card-unit :items="items()">
                    <template #title>{{ t('club_label_id') }}: {{ club.id }}</template>
                </card-unit>
            </div>
            <div class="pt-8" style="clear: both">
                <div class="form-subtitle mb-4">{{ t('club_label_sections') }}</div>
                <v-card
                    v-for="section in club.sections"
                    :key="section.id"
                    elevation="0"
                    class="mb-4 pa-4 bordered"
                >
                    <div class="customized-primary--text mb-2" style="font-weight:600">{{ section.name }}</div>
                    <v-simple-table dense>
                        <template #default>
                            <thead>
                            <tr>
                                <th style="width:160px">{{ t('club_element_label_type') }}</th>
                                <th>{{ t('club_element_label_name') }}</th>
                                <th style="width:120px">{{ t('club_element_label_premium') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="section.elements.length === 0">
                                <td colspan="3" class="text-center">{{ t('general_text_no_data') }}</td>
                            </tr>
                            <tr
                                v-for="element in section.elements"
                                :key="element.id"
                            >
                                <td>{{ t(`club_element_type_${element.type}`) }}</td>
                                <td>{{ element.name }}</td>
                                <td>{{ element.isPremium ? t('general_text_yes') : t('general_text_no') }}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </div>
        </div>
    </v-layout>
</div>
